<template>
  <q-dialog title="新增订单" :visible="isVisible" width="500px" :innerScroll="false" @close="handleClose" @cancel="handleClose">
    <el-form
      ref="addForm"
      :model="addForm"
      label-width="100px"
      :rules="rules"
      class="dialogContent"
      v-loading="loadingLog"
    >
      <el-form-item label="平台单号：" prop="orderNo" v-if="!addText.show">
        <el-input v-model="addForm.orderNo" placeholder="可批量新增" size="small" show-word-limit></el-input>
      </el-form-item>
      <div v-else style="margin-top: 20px">
        <span>{{ addText.successNum || 0 }}条成功，</span><span>{{ addText.failNum || 0 }}条失败</span>
        <p>失败平台单号：{{ (addText.failPlatOrderNoList && addText.failPlatOrderNoList.join("，")) || "-" }}</p>
      </div>
    </el-form>
    <template slot="footer" v-if="!addText.show">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确认</el-button>
    </template>
  </q-dialog>
</template>

<script>
import { debounce } from "@/utils/index";
export default {
  name: "AddDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  data() {
    return {
      loadingLog: false,
      addForm: {
        orderNo: "",
      },
      addText: {},
      rules: {
        orderNo: [{ required: true, message: "请输入平台单号", trigger: "blur" }],
      },
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.addForm = {
        orderNo: "",
      };
      this.addText = {};
      if (this.$refs.addForm) {
        this.$refs.addForm.resetFields();
      }
    },
    handleClose() {
      this.isVisible = false;
    },
    handleConfirm: debounce(function () {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingLog = true;
        this.$q.dataImport
          .batchAddUnsaleOrder({
            data: { platOrderNoList: this.addForm.orderNo.split(" ") },
          })
          .then((data) => {
            if (data.code === "200") {
              this.addText = {
                ...data.data,
                show: true,
              };
              this.$emit("success");
            } else {
              this.$message.error(data.message);
            }
          })
          .finally((_) => {
            this.loadingLog = false;
          });
      });
    }, 1000),
  },
};
</script>

<style lang="stylus" scoped>
.dialogContent
  max-height 70vh
  overflow-y auto
</style>
